<template>
  <footer class="app-footer" :style="styles">
    <div class="box-left">
      <p>{{ copyrightText }}</p>
    </div>
    <div class="box-right" :class="{wide: isWideScreen}">
      <ul>
        <li
          @click="
            openModalPage('Terms and Conditions', 'pages', {
              index: 'terms-and-conditions',
            })
          "
        >
          <a href="#">Terms and Conditions</a>
        </li>
        <li
          @click="
            openModalPage('Privacy Policy', 'pages', {
              index: 'privacy-policy',
            })
          "
          :class="{ stacked: stacked }"
        >
          <a href="#">Privacy Policy</a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'AppFooter',
  created() {
    this.defaultHeight = this.height;
  },
  data() {
    return {
      defaultHeight: 0,
    };
  },
  computed: {
    ...mapState({
      height: (state) => state.system.config.footer.height,
      text: (state) => state.system.config.footer.text,
      isInternalProcessLayout: (state) => state.system.config.isInternalProcessLayout,
    }),
    isWideScreen() {
      return this.isInternalProcessLayout;
    },
    stacked() {
      return parseInt(this.height, 10) > parseInt(this.defaultHeight, 10);
    },
    styles() {
      return {
        height: `${this.height}px`,
      };
    },
    copyrightText() {
      const now = new Date();
      const currentYear = now.getFullYear();
      const regex = /{currentYear}|\d+/gi;
      return this.text.replace(regex, currentYear);
    },
  },
  methods: {
    openModalPage(title, component, data) {
      this.$store.dispatch('openModal', {
        title,
        component,
        data,
      });
    },
  },
};
</script>

<style lang="scss">
.app-footer {
  background-color: $mds-color-neutral-95;
  color: $mds-color-neutral-20;
  font-family: $mds-font-family-sans-serif;
  font-size: $mds-font-size-s;
  display: flex;
  justify-content: space-between;
  height: 50px;

  p {
    margin: 0 0 0 $mds-space-2-x;
    padding: $mds-space-inset-2-x 0;
  }

  ul {
    padding: $mds-space-inset-2-x 0;
    margin: 0 $mds-space-2-x 0 0;
  }

  li {
    display: inline-block;
    list-style-type: none;
    margin-left: $mds-space-1-and-a-half-x;
  }

  .stacked {
    margin-top: $mds-space-1-x;
  }

  .box-right {
    &.wide {
      margin-right: 70px;
    }
  }

  a {
    color: $mds-color-neutral-20;
  }
}
</style>
